import { defineRecipe } from '@chakra-ui/react/styled-system';

const closeButtonRecipe = defineRecipe({
  className: 'close-button',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4',
    cursor: 'pointer',
    _disabled: {
      cursor: 'not-allowed',
      color: 'icon/disabled',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&:active': {
        backgroundColor: 'transparent',
      },
    },
  },
  variants: {
    size: {
      xs: { h: '24', w: '24' },
      sm: { h: '32', w: '32' },
      md: { h: '40', w: '40' },
    },
    colorVariant: {
      neutral: {
        color: 'color/neutral/strong',
        '&:hover': { backgroundColor: 'color/neutral/subtle' },
        '&:active': { backgroundColor: 'color/neutral/moderate' },
      },
      blue: {
        color: 'color/blue/strong',
        '&:hover': { backgroundColor: 'color/blue/subtle' },
        '&:active': { backgroundColor: 'color/blue/moderate' },
      },
      green: {
        color: 'color/green/strong',
        '&:hover': { backgroundColor: 'color/green/subtle' },
        '&:active': { backgroundColor: 'color/green/moderate' },
      },
      red: {
        color: 'color/red/strong',
        '&:hover': { backgroundColor: 'color/red/subtle' },
        '&:active': { backgroundColor: 'color/red/moderate' },
      },
      yellow: {
        color: 'color/yellow/strong',
        '&:hover': { backgroundColor: 'color/yellow/subtle' },
        '&:active': { backgroundColor: 'color/yellow/moderate' },
      },
      purple: {
        color: 'color/purple/strong',
        '&:hover': { backgroundColor: 'color/purple/subtle' },
        '&:active': { backgroundColor: 'color/purple/moderate' },
      },
      indigo: {
        color: 'color/indigo/strong',
        '&:hover': { backgroundColor: 'color/indigo/subtle' },
        '&:active': { backgroundColor: 'color/indigo/moderate' },
      },
      white: {
        color: 'icon/on-contrast',
      },
    },
  },
  defaultVariants: {
    colorVariant: 'neutral',
    size: 'xs',
  },
});

export default closeButtonRecipe;
